module.exports = __webpack_public_path__ + "FuturaStd-Book.otf?921351f146d78d55c8030239527bf2d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FuturaStd-Book.otf
// module id = 94
// module chunks = 0